import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('VIDEO_CATEGORIES').plugin(axiosPlugin, {template: "array"});

let fetchVideoCategoriesAction = redux.fetchActionGet();

//export const fetchVideoCategories = (kind="", query = {}) => fetchVideoCategoriesAction(`/tags-list/${kind}/childrens?${queryString.stringify(query)}`);
export const fetchVideoCategories = (query = {}) => fetchVideoCategoriesAction(`/facettes/suggestion-video?${queryString.stringify(query)}`);

export const videoCategories = redux.reducer();